module.exports = __webpack_public_path__ + "static/media/PCCLoginHover.fa3cb303.svg";